<template>
  <DragPanel
    title="图层"
    :defaultTop="20"
    :defaultLeft="20"
    :closePanel="closePanel"
    class="common-drag-panel">
    <div class="common-tree-box">
      <el-tree
        class="dialog-tree-small-primary"
        ref="sceneDataTree"
        :data="sceneData"
        :props="defaultProps"
        node-key="nodeId"
        highlight-current
        show-checkbox
        :expand-on-click-node="false"
        :check-strictly="isRvtGroupMode"
        @node-expand="handeNodeExpand"
        @node-click="handleNodeClick"
        @check="handleNodeCheck">
        <template slot-scope="{ data }">
          <div :class="getTreeNodeClassName(data)">
            <div :class="getNodeLabelClassName(data)">
              <div
                class="icon-box"
                v-if="data.nodeType && data.nodeType !== 2">
                <icon-svg :icon-class="getIcon(data)" />
              </div>
              <div class="label-box">
                <div
                  v-if="data.isRvtGroup"
                  class="rvt-group-label">
                  <icon-svg
                    size="20"
                    class="icon"
                    title="Group节点"
                    icon-class="icon-group" />
                  <div
                    class="group-name text-overflow"
                    :title="data.nodeName">
                    {{ data.nodeName }}
                  </div>
                </div>
                <div
                  v-else
                  :title="data.nodeName"
                  class="text-overflow">
                  {{ data.nodeName }}
                </div>
              </div>
            </div>
            <div class="custom-button-box">
              <el-button
                v-if="data.hasTexture"
                type="text"
                size="small"
                title="纹理动画"
                @click.stop="openTexturePanel(data)">
                <icon-svg
                  icon-class="ic-wenlidonghua3"
                  class="icon" />
              </el-button>
              <el-button
                v-if="data.nodeType === 3 && data.hasRvtGroup"
                type="text"
                size="small"
                @click.stop="switchOrganizeDataMode">
                <div class="btn-icon-box">
                  <icon-svg
                    title="默认目录树"
                    icon-class="icon-biaogao"
                    :class="`icon ${isRvtGroupMode ? '' : 'active'}`" />
                  <icon-svg
                    title="Group目录树"
                    icon-class="icon-fenzu"
                    :class="`icon ${isRvtGroupMode ? 'active' : ''}`" />
                </div>
              </el-button>
            </div>
          </div>
        </template>
      </el-tree>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'

import { Store } from '@/utils/store'
import { resetElemAttr } from '@/utils/engineUtils'

import {
  getProjectTree,
  getProjectTreeSubNodes,
  getProjectTreeSubNodesByLazy,
  getBimElemTreeNodesByGroupService,
  getProjectTreeChildren,
  getProjectTreeChildrenByLazy,
  getBimElemIdsByGroupService
} from '@/service/interface'

export default {
  data() {
    return {
      // 当前是否以分组组织目录树
      isRvtGroupMode: false,
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },

      defaultTreeData: [],
      rvtGroupTreeData: []
    }
  },
  props: {
    sceneData: Array,
    openTexturePanel: Function,
    closePanel: Function,
    focusDataSets: Function,
    focusElems: Function,
    showDataSets: Function,
    hideDataSets: Function,
    showElement: Function,
    hiddenElement: Function,
    highLightWaters: Function,
    showWaters: Function,
    hideWaters: Function,
    highLightExtrudes: Function,
    showExtrudes: Function,
    hideExtrudes: Function
  },
  components: {
    DragPanel
  },
  mounted() {
    this.$eventManage.on('dataSetLoadFinish', this.onDataSetLoadFinish)
  },
  beforeDestroy() {
    this.$eventManage.off('dataSetLoadFinish', this.onDataSetLoadFinish)
  },
  methods: {
    onDataSetLoadFinish() {
      let allRootNodes = this.findAllNodeByLevel(this.sceneData, 3)

      this.$nextTick(() => {
        const domRef = this.$refs.sceneDataTree
        const chenkedKeys = allRootNodes.map(item => item.nodeId)
        chenkedKeys.forEach(key => {
          const node = domRef.getNode(key)
          node.expanded = true
        })

        domRef.setCheckedKeys(chenkedKeys)
      })
    },
    switchOrganizeDataMode() {
      this.isRvtGroupMode = !this.isRvtGroupMode

      let leafNodes = this.findAllNodeByLevel(this.sceneData, 2)
      // prettier-ignore
      const bimDataSets = leafNodes.filter(el => el.dataSetType === 0 && el.viewStatus !== 2)
      // 恢复所有数据集的所有构件颜色和透明度
      bimDataSets.forEach(dataSet => {
        const dataSetId = dataSet.dataSetId.replaceAll('-', '')
        resetElemAttr(dataSetId, [])
      })

      let fileNodes = []
      bimDataSets.forEach(dataSet => {
        const subNodes = dataSet.subNodes
        let filterFileNodes = subNodes.filter(
          el => el.customNodeType === 'pakFile'
        )
        fileNodes = [...filterFileNodes, ...fileNodes]
      })
      // prettier-ignore
      const treeDataMap = this.isRvtGroupMode ? this.rvtGroupTreeData : this.defaultTreeData
      const domRef = this.$refs.sceneDataTree
      let expandKeys = []
      fileNodes.forEach(item => {
        const node = domRef.getNode(item.nodeId)
        node.expanded = false
        setTimeout(() => {
          let find = treeDataMap.find(el => el.parentNodeId === item.nodeId)
          if (find) {
            item.subNodes = find.subNodes
            expandKeys.push(item.nodeId)
          } else {
            item.subNodes = [{ name: '' }]
          }

          if (this.isRvtGroupMode && !item.hasRvtGroup) {
            item.subNodes = []
          }
        }, 500)
      })

      this.$nextTick(() => {
        expandKeys.forEach(item => {
          const node = domRef.getNode(item)
          node.expanded = true
        })

        let checkedKeys = domRef.getCheckedKeys()
        let bimRootNode = this.sceneData.find(el => el.dataSetType === 0)
        let find = checkedKeys.find(el => el === bimRootNode.nodeId)
        if (!find) {
          checkedKeys.push(bimRootNode.nodeId)
        }

        domRef.setCheckedKeys(checkedKeys)
      })
    },
    handeNodeExpand(nodeData, node) {
      if (!nodeData.customNodeType) return
      if (nodeData.dataSetType !== 0) return

      if (nodeData.customNodeType === 'dataSet') {
        this.expandDataSetNode(nodeData, node)
        return
      }

      if (this.isRvtGroupMode) {
        if (!this.isRvtGroupNode(node)) {
          nodeData.subNodes = []
          return
        }
        this.expandNodeByRvtGroup(nodeData, node)
      } else {
        this.expandNodeByDefault(nodeData, node)
      }
    },
    async handleNodeClick(nodeData, node) {
      if (this.isWaterNode(nodeData)) {
        this.highLightWaterList(nodeData)
        return
      }

      if (this.isExtrudeNode(nodeData)) {
        this.highLightExtrudeList(nodeData)
        return
      }

      if (!nodeData.customNodeType) {
        let allDataSets = this.findAllNodeByLevel([nodeData], 2)
        if (this.isEntityNode(nodeData)) {
          this.highLightEntityList(allDataSets)
        } else {
          this.focusDataSetList(allDataSets, nodeData.nodeType)
        }
        return
      }

      if (nodeData.customNodeType === 'dataSet') {
        if (nodeData.dataSetType === 19) {
          this.highLightEntityList([nodeData])
        } else {
          this.focusDataSetList([nodeData], nodeData.nodeType)
        }
        return
      }

      if (nodeData.customNodeType === 'pakFile') {
        const childNodeIds = await this.getElemIdsByDefaultNode(nodeData)
        if (childNodeIds.length) {
          const dataSetId = nodeData.dataSetId.replaceAll('-', '')
          const dataSets = [{ dataSetId, elemIds: childNodeIds }]
          this.focusElems(dataSets)
        }
        return
      }

      if (this.isRvtGroupMode) {
        const childNodeIds = await this.getElemIdsByRvtGroupNode(nodeData, node)
        if (childNodeIds.length) {
          const dataSetId = nodeData.dataSetId.replaceAll('-', '')
          const dataSets = [{ dataSetId, elemIds: childNodeIds }]
          this.focusElems(dataSets)
        }
      } else {
        const childNodeIds = await this.getElemIdsByDefaultNode(nodeData)
        if (childNodeIds.length) {
          const dataSetId = nodeData.dataSetId.replaceAll('-', '')
          const dataSets = [{ dataSetId, elemIds: childNodeIds }]
          this.focusElems(dataSets)
        }
      }
    },

    async handleNodeCheck(nodeData) {
      let domRef = this.$refs.sceneDataTree
      let nodeObject = domRef.getNode(nodeData)

      if (this.isWaterNode(nodeData)) {
        let leafNodes = this.findAllNodeByLevel([nodeData], 2)
        if (!nodeObject.checked) {
          this.hideWaterList(leafNodes)
        } else {
          this.showWaterList(leafNodes)
        }

        if (this.isRvtGroupMode) {
          this.setChildNodesCheckStatus(nodeData, nodeObject.checked)
          this.setParentNodesCheckStatus(nodeObject.parent)
        }
        return
      }

      if (this.isExtrudeNode(nodeData)) {
        let leafNodes = this.findAllNodeByLevel([nodeData], 2)
        if (!nodeObject.checked) {
          this.hideExtrudeList(leafNodes)
        } else {
          this.showExtrudeList(leafNodes)
        }

        if (this.isRvtGroupMode) {
          this.setChildNodesCheckStatus(nodeData, nodeObject.checked)
          this.setParentNodesCheckStatus(nodeObject.parent)
        }
        return
      }

      if (nodeData.dataSetType !== 0) {
        let allDatasets = this.findAllNodeByLevel([nodeData], 2)
        let dataSets = this.getToggleViewDataSets(allDatasets)
        if (!nodeObject.checked) {
          this.hideDataSets(dataSets)
        } else {
          this.showDataSets(dataSets)
        }

        if (this.isRvtGroupMode) {
          this.setChildNodesCheckStatus(nodeData, nodeObject.checked)
          this.setParentNodesCheckStatus(nodeObject.parent)
        }

        return
      }

      if (!nodeData.customNodeType) {
        let allDatasets = this.findAllNodeByLevel(nodeData.subNodes, 2)
        let dataSets = this.getToggleViewDataSets(allDatasets)
        if (!nodeObject.checked) {
          this.hideDataSets(dataSets)
        } else {
          this.showDataSets(dataSets)
        }

        if (this.isRvtGroupMode) {
          this.setChildNodesCheckStatus(nodeData, nodeObject.checked)
        }

        return
      }

      if (nodeData.customNodeType === 'dataSet') {
        let dataSets = this.getToggleViewDataSets([nodeData])
        if (!nodeObject.checked) {
          this.hideDataSets(dataSets)
        } else {
          this.showDataSets(dataSets)
        }

        if (this.isRvtGroupMode) {
          this.setChildNodesCheckStatus(nodeData, nodeObject.checked)
        }

        return
      }

      if (nodeData.customNodeType === 'pakFile') {
        const elemIds = await this.getElemIdsByDefaultNode(nodeData)
        if (!nodeObject.checked) {
          if (elemIds.length) {
            const dataSetId = nodeData.dataSetId.replaceAll('-', '')
            this.hiddenElement(dataSetId, elemIds)
          }
        } else {
          if (elemIds.length) {
            const dataSetId = nodeData.dataSetId.replaceAll('-', '')
            this.showElement(dataSetId, elemIds)
          }
        }

        if (this.isRvtGroupMode) {
          this.setChildNodesCheckStatus(nodeData, nodeObject.checked)
        }

        return
      }

      if (this.isRvtGroupMode) {
        const dataSetId = nodeData.dataSetId.replaceAll('-', '')
        const elemIds = await this.getElemIdsByRvtGroupNode(
          nodeData,
          nodeObject
        )
        if (!nodeObject.checked) {
          if (elemIds.length) {
            this.hiddenElement(dataSetId, elemIds)
          }
        } else {
          if (elemIds.length) {
            this.showElement(dataSetId, elemIds)
          }
        }

        this.setChildNodesCheckStatus(nodeData, nodeObject.checked)
      } else {
        const dataSetId = nodeData.dataSetId.replaceAll('-', '')
        const elemIds = await this.getElemIdsByDefaultNode(nodeData)
        if (!nodeObject.checked) {
          if (elemIds.length) {
            this.hiddenElement(dataSetId, elemIds)
          }
        } else {
          if (elemIds.length) {
            this.showElement(dataSetId, elemIds)
          }
        }
      }
    },
    async expandDataSetNode(nodeData, node) {
      if (this.isNodeExpanded(nodeData)) {
        if (node.checked) {
          node.childNodes.forEach(item => {
            item.checked = true
          })
        }
        return
      }

      node.expanded = false
      node.loading = true
      const params = { dataSetId: nodeData.dataSetId }
      const response = await getProjectTree(params)
      if (response.isSuccess) {
        const subNodes = this.formatDataSetSubNodes(nodeData, response.data)
        nodeData.subNodes = subNodes

        this.$nextTick(() => {
          if (node.checked) {
            node.childNodes.forEach(item => {
              item.checked = true
            })
          }

          node.expanded = true
          node.loading = false
        })
      } else {
        this.showError(response.errMsg)
      }
    },
    expandNodeByRvtGroup(nodeData, node) {
      if (this.isNodeExpanded(nodeData)) {
        if (node.checked) {
          node.childNodes.forEach(item => {
            item.checked = true
          })
        }
        return
      }

      this.loadRvtGroupNodes(nodeData, node)
    },
    async loadRvtGroupNodes(nodeData, node) {
      node.expanded = false
      node.loading = true

      let params = {
        dataSetId: nodeData.dataSetId,
        fileIntId: nodeData.fileIntId,
        uniqueId: nodeData.uniqueId
      }

      const response = await getBimElemTreeNodesByGroupService(params)
      if (response.isSuccess) {
        const subNodes = this.formatPakChildNode(nodeData, response.data)
        nodeData.subNodes = subNodes

        let find = this.rvtGroupTreeData.find(item => {
          return item.uniqueId === nodeData.uniqueId
        })
        if (!find) {
          let obj = {
            parentNodeId: nodeData.nodeId,
            subNodes: subNodes
          }
          this.rvtGroupTreeData.push(obj)
        }
        this.$nextTick(() => {
          if (node.checked) {
            node.childNodes.forEach(item => {
              item.checked = true
            })
          }
          node.expanded = true
          node.loading = false
        })
      } else {
        this.$message.error(response.errMsg)
      }
    },
    expandNodeByDefault(nodeData, node) {
      if (this.isNodeExpanded(nodeData)) {
        if (node.checked) {
          node.childNodes.forEach(item => {
            item.checked = true
          })
        }
        return
      }

      let enableLazyLoading = nodeData.enableLazyLoading
      if (enableLazyLoading) {
        this.loadDefaultNodesByLazy(nodeData, node)
      } else {
        this.loadDefaultNodes(nodeData, node)
      }
    },
    async loadDefaultNodes(nodeData, node) {
      node.expanded = false
      node.loading = true

      let params = {
        dataSetId: nodeData.dataSetId,
        fileIntId: nodeData.fileIntId,
        uniqueId: nodeData.uniqueId
      }
      const response = await getProjectTreeSubNodes(params)
      if (response.isSuccess) {
        const subNodes = this.formatPakChildNode(nodeData, response.data)
        nodeData.subNodes = subNodes

        let find = this.defaultTreeData.find(item => {
          return item.uniqueId === nodeData.uniqueId
        })
        if (!find) {
          let obj = {
            parentNodeId: nodeData.nodeId,
            subNodes: subNodes
          }
          this.defaultTreeData.push(obj)
        }

        this.$nextTick(() => {
          if (node.checked) {
            node.childNodes.forEach(item => {
              item.checked = true
            })
          }
          node.expanded = true
          node.loading = false
        })
      }
    },
    async loadDefaultNodesByLazy(nodeData, node) {
      node.expanded = false
      node.loading = true

      let params = {
        dataSetId: nodeData.dataSetId,
        parentNodeIntId: nodeData.nodeIntId
          ? Number(nodeData.nodeIntId)
          : Number(nodeData.fileIntId),
        hostFileId: Number(nodeData.fileIntId)
      }

      const response = await getProjectTreeSubNodesByLazy(params)
      if (response.isSuccess) {
        nodeData.subNodes = response.data.map(item => {
          item['customNodeType'] = 'pakChildNode'
          item['dataSetType'] = nodeData.dataSetType
          item['dataSetId'] = nodeData.dataSetId
          item['fileIntId'] = nodeData.fileIntId
          item['uniqueId'] = item.levelCode
          item['name'] = item.nodeName
          item['enableLazyLoading'] = true
          item.subNodes = [{ name: '' }]
          return item
        })

        this.$nextTick(() => {
          if (node.checked) {
            node.childNodes.forEach(item => {
              item.checked = true
            })
          }

          node.expanded = true
          node.loading = false
        })
      } else {
        this.$message.error(response.errMsg)
      }
    },
    getQueryDefaultElemIdParams(nodeData) {
      if (nodeData.customNodeType === 'pakFile') {
        let params = {
          dataSets: [
            {
              dataSetId: nodeData.dataSetId,
              hostFileId: nodeData.fileIntId
            }
          ]
        }
        return params
      }

      let childNodeIds = this.getAllChildFieldValues([nodeData], 'childNodeId')
      let dataSets = childNodeIds.map(item => {
        let obj = {
          dataSetId: nodeData.dataSetId,
          childNodeId: item
        }
        return obj
      })
      let params = { dataSets, version: this.version }
      return params
    },
    async getElemIdsByDefaultNode(nodeData) {
      if (nodeData.enableLazyLoading) {
        let params = {
          dataSetId: nodeData.dataSetId,
          hostFileId: Number(nodeData.fileIntId),
          levelCode: nodeData.levelCode ? nodeData.levelCode : undefined
        }

        const response = await getProjectTreeChildrenByLazy(params)
        if (response.isSuccess) {
          let childNodeIds = response.data
          return childNodeIds
        } else {
          this.$message.error(response.errMsg)
        }
      } else {
        let params = this.getQueryDefaultElemIdParams(nodeData)

        const response = await getProjectTreeChildren(params)
        if (response.isSuccess) {
          let dataSets = response.data
          let childNodeIds = dataSets[0].childNodeIds
          return childNodeIds
        } else {
          this.$message.error(response.errMsg)
        }
      }
    },
    getQueryRvtGroupElemIdParams(nodeData, node) {
      let childNodeId = this.getAllChildFieldValues([nodeData], 'childNodeId')
      const fileNodeData = this.findFileNodeData(node)
      let params = {
        dataSetId: nodeData.dataSetId,
        hostFileId: fileNodeData.fileIntId,
        childNodeId
      }
      return params
    },
    async getElemIdsByRvtGroupNode(nodeData, node) {
      let params = this.getQueryRvtGroupElemIdParams(nodeData, node)

      let response = await getBimElemIdsByGroupService(params)

      if (response.isSuccess) {
        let data = response.data
        let childNodeIds = data.childNodeIds
        return childNodeIds
      } else {
        this.$message.error(response.message)
      }
    },
    setParentNodesCheckStatus(node) {
      if (!node) return

      const childNodes = node.childNodes

      // 检查子节点状态
      const checkedCount = childNodes.filter(el => el.checked).length
      const total = childNodes.length

      // 设置当前节点状态
      if (checkedCount === 0) {
        // 全部未选中
        node.checked = false
        node.indeterminate = false
      } else if (checkedCount === total) {
        // 全部选中
        node.checked = true
        node.indeterminate = false
      } else {
        // 部分选中
        node.checked = false
        node.indeterminate = true
      }

      // 递归处理父节点
      if (node.parent) {
        this.setParentNodesCheckStatus(node.parent)
      }
    },
    setChildNodesCheckStatus(nodeData, isChecked) {
      // prettier-ignore
      const childNodeKeys = this.getAllChildFieldValues(nodeData.subNodes, 'nodeId')
      childNodeKeys.forEach(key => {
        const node = this.$refs.sceneDataTree.getNode(key)
        if (node) {
          node.checked = isChecked
        }
      })
    },
    setCurrentKey(nodeId) {
      let domRef = this.$refs.sceneDataTree
      domRef.setCurrentKey(nodeId)
    },
    getToggleViewDataSets(allDatasets) {
      let dataSets = allDatasets.map(item => {
        let obj = {
          dataSetType: item.dataSetType
        }
        if (item.dataSetType === 19) {
          let componentInfo = item.componentInfo
          obj.dataSetId = componentInfo.dataSetId.replaceAll('-', '')
          obj.elemId = componentInfo.elemId
        } else {
          obj.dataSetId = item.dataSetId.replaceAll('-', '')
        }
        return obj
      })
      return dataSets
    },
    highLightEntityList(allDataSets) {
      let dataSets = []
      allDataSets.forEach(item => {
        let componentInfo = item.componentInfo
        let find = dataSets.find(el => el.dataSetId === componentInfo.dataSetId)
        if (find) {
          find.elemIds.push(componentInfo.elemId)
        } else {
          let obj = {
            dataSetId: componentInfo.dataSetId,
            elemIds: [componentInfo.elemId]
          }
          dataSets.push(obj)
        }
      })

      dataSets.forEach(item => {
        item.dataSetId = item.dataSetId.replaceAll('-', '')
      })
      this.focusElems(dataSets)
    },
    focusDataSetList(allDataSets, nodeType) {
      allDataSets = allDataSets.filter(el => el.viewStatus !== 2)
      if (!allDataSets.length) {
        if (nodeType !== 2) {
          this.$message.warning('当前节点下不存在有效的数据集，无法定位')
        } else {
          this.$message.warning('当前数据集已失效，无法定位')
        }
        return
      }

      let dataSets = allDataSets.map(item => {
        let dataSetId = item.dataSetId.replaceAll('-', '')
        let dataSetType = item.dataSetType
        let obj = { dataSetId, dataSetType }
        return obj
      })
      this.focusDataSets(dataSets)
    },
    highLightWaterList(nodeData) {
      let waterList = this.findAllNodeByLevel([nodeData], 2)
      let waterIds = waterList.map(item => item.waterId)

      this.highLightWaters(waterIds)
    },
    highLightExtrudeList(nodeData) {
      let extrudeList = this.findAllNodeByLevel([nodeData], 2)
      let extrudeIds = extrudeList.map(item => item.extrudeId)

      this.highLightExtrudes(extrudeIds)
    },
    showWaterList(waterList) {
      let waterIds = waterList.map(item => item.waterId)
      this.showWaters(waterIds)
    },
    hideWaterList(waterList) {
      let waterIds = waterList.map(item => item.waterId)
      this.hideWaters(waterIds)
    },
    showExtrudeList(extrudeList) {
      let extrudeIds = extrudeList.map(item => item.extrudeId)
      this.showExtrudes(extrudeIds)
    },
    hideExtrudeList(extrudeList) {
      let extrudeIds = extrudeList.map(item => item.extrudeId)
      this.hideExtrudes(extrudeIds)
    },
    formatDataSetSubNodes(dataSetInfo, subNodes) {
      const { dataSetId, dataSetType } = dataSetInfo
      const formatType = subNodes[0]?.formatType
      if (formatType === 1) {
        let treeData = subNodes[0].files
        treeData.forEach(item => {
          item['customNodeType'] = 'pakFile'
          item['formatType'] = formatType
          item['nodeName'] = item.fileName
          item['nodeId'] = `${dataSetId}-${item.uniqueId}`
          item['dataSetType'] = dataSetType
          item['dataSetId'] = dataSetId
          item.subNodes = [{ nodeName: '' }]
          if (this.isRvtGroupMode && !item.hasRvtGroup) {
            item.subNodes = []
          }
        })
        return treeData
      }
      if (formatType === 2) {
        subNodes.forEach(item => {
          item.subNodes = item.files
          item.subNodes.forEach(node => {
            node['customNodeType'] = 'pakFile'
            item['formatType'] = formatType
            node['nodeName'] = node.fileName
            node['nodeId'] = `${dataSetId}-${node.uniqueId}`
            node['dataSetType'] = dataSetType
            node['dataSetId'] = dataSetId
            node.subNodes = [{ nodeName: '' }]
            if (this.isRvtGroupMode && !node.hasRvtGroup) {
              node.subNodes = []
            }
          })
        })
        let treeData = subNodes[0].subNodes
        return treeData
      }
    },
    formatPakChildNode(pakNodeInfo, subNodes) {
      const { dataSetId, dataSetType } = pakNodeInfo

      for (let node of subNodes) {
        node['childNodeId'] = node.nodeId
        node['nodeId'] = `${dataSetId}-${
          node.uniqueId ? node.uniqueId : node.levelCode
        }`
        node['nodeName'] = node.name ? node.name : node.nodeName
        node['subNodes'] = node.nodes
        node['customNodeType'] = 'pakChildNode'
        node['dataSetType'] = dataSetType
        node['dataSetId'] = dataSetId
        if (node.subNodes && node.subNodes.length) {
          this.formatPakChildNode(pakNodeInfo, node.subNodes)
        }
      }

      return subNodes
    },
    findFileNodeData(node) {
      const nodeData = node.data
      if (nodeData.formatType === 1) return nodeData
      if (nodeData.customNodeType === 'pakFile') return nodeData

      if (node.parent) {
        return this.findFileNodeData(node.parent)
      }
    },
    getAllChildFieldValues(nodes, field) {
      let fieldArray = []
      const recursion = item => {
        if (item[field]) {
          fieldArray.push(item[field])
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(node => {
            recursion(node)
          })
        }
      }

      nodes.forEach(item => {
        recursion(item)
      })

      return fieldArray
    },
    findAllNodeByLevel(data, level) {
      const array = []

      const traverse = item => {
        if (item.nodeType && item.nodeType === level) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    },
    isEntityNode(nodeData) {
      let allData = this.findAllNodeByLevel([nodeData], 2)
      let isEntityNode = allData.every(el => el.dataSetType === 19)
      return isEntityNode
    },
    isWaterNode(nodeData) {
      let dataSetType = nodeData.dataSetType
      return dataSetType === 23
    },
    isExtrudeNode(nodeData) {
      let dataSetType = nodeData.dataSetType
      return dataSetType === 24
    },
    isNodeExpanded(nodeData) {
      return nodeData.subNodes[0]?.uniqueId
    },
    isRvtGroupNode(node) {
      const fileNodeData = this.findFileNodeData(node)
      return fileNodeData.hasRvtGroup
    },
    getTreeNodeClassName(nodeInfo) {
      let className = 'custom-node-box'
      if (nodeInfo.disabled) {
        className += ' node-disabled'
      }

      return className
    },
    getNodeLabelClassName(nodeInfo) {
      let nodeType = nodeInfo.nodeType
      let className = 'node-label-box'

      if (nodeType === 3) {
        className += ' node-label-bold'
      }

      return className
    },
    getIcon(nodeInfo) {
      let nodeType = nodeInfo.nodeType
      if (nodeType === 1) return 'ic-ico_folder'

      let dataSetType = nodeInfo.dataSetType
      switch (dataSetType) {
        case 0:
          return 'ic-moxing'
        case 13:
          return 'ic-yg'
        case 10:
          return 'ic-WMTS'
        case 11:
          return 'ic-qxsy'
        case 15:
          return 'ic-dy'
        case 17:
          return 'ic-yuanjian'
        case 18:
          return 'ic-yuanjian'
        case 19:
          return 'ic-yuanjian'
        case 21:
          return 'ic-CADwapian'
        case 22:
          return 'ic-shiliangwapian-2'
        case 23:
          return 'ic-shuimian'
        case 24:
          return 'ic-kaiwa'
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  top: 124px;
  left: 10px;
  width: 360px;
  height: calc(100% - 190px);

  :deep(.content) {
    height: calc(100% - 40px);

    .common-tree-box {
      height: 100%;
      padding: 10px;

      .el-tree-node > .el-tree-node__content {
        height: 24px;

        .el-checkbox {
          display: flex;
          align-items: center;
        }

        .el-tree-node__expand-icon {
          margin-top: 0;
          color: var(--tree-expand-icon-color);
        }
        .expanded {
          color: var(--tree-not-expand-icon-color);
        }
      }

      .custom-node-box {
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        overflow: hidden;

        .node-label-box {
          display: flex;
          align-items: center;
          overflow: hidden;

          .label-box {
            margin-left: 5px;
            font-size: 14px;
            font-weight: 400;

            .rvt-group-label {
              display: flex;
              align-items: center;
              .icon {
                margin-right: 4px;

                use {
                  color: var(--bimview-rvt-group-color) !important;
                }
              }

              .group-name {
                color: var(--bimview-rvt-group-color) !important;
              }
            }
          }
        }

        .node-label-bold {
          font-weight: bold;
        }

        .custom-button-box {
          padding: 0px 10px;

          .btn-icon-box {
            display: flex;
            align-items: center;
            gap: 8px;

            .icon {
              font-size: 14px;
              color: var(--default-color);

              &:hover {
                use {
                  color: var(--base-primary-bgColor);
                }
              }

              &.active {
                use {
                  color: var(--base-primary-bgColor);
                }
              }
            }
          }
        }
      }
      .node-disabled {
        .label-box {
          color: var(--base-dark25-color);
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
